// extracted by mini-css-extract-plugin
module.exports = {"container":"_34wPb","loader":"_2hrBG","heading":"_3QwZZ"};